<template>
  <b-container class="wrap-main-news">
    <div class="wrap-content">
      <div class="box-head">
        <Title
          main="A D M A N"
          des="NEWS & ACTIVITIES"
        />
        <b-row
          align-v="center"
          class="box-filter"
        >
          <b-col
            cols="12"
            md="8"
            class="box-input"
          >
            <input v-model="inputFilter" type="text">
            <button>
              <img src="@/assets/icons/ic-search.svg">
            </button>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="box-select"
          >
            <select v-model="selectPublish">
              <option
                v-for="(publish, i) in publishs"
                :key="i"
                :value="publish"
              >
                {{ publish }}
              </option>
            </select>
          </b-col>
        </b-row>
      </div>
      <div class="box-cate">
        <hr>
        <div>ALL</div>
      </div>

      <article
        v-if="newsList"
        class="box-card"
      >
        <b-row>
          <b-col
            v-for="news in newsList.slice(0, listNum)"
            :key="news.id"
            cols="12"
            md="6"
            lg="4"
            class="col"
          >
            <router-link :to="news.route">
              <Card
                :name="news.name"
                :published="news.publish"
                :dec="news.dec"
                :imgUrl="news.imgUrl"
              />
            </router-link>
          </b-col>
        </b-row>
        <div
          v-if="showBtn"
          class="box-view-more-btn"
        >
          <button @click.prevent="loadListMore()">View More</button>
        </div>
      </article>

      <div
        v-if="!isLoading && newsList.length === 0"
        class="box-empty"
      >
        NO DATA
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
const Title = () => import('@/components/About/Parts/Title')
const Card = () => import('./Parts/Card')

export default {
  components: {
    Title,
    Card
  },

  data () {
    return {
      newsList: [],
      publishs: [],
      selectPublish: 'All Years',
      listNum: 6,
      clickCount: 0,
      showBtn: true,
      inputFilter: ''
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.news.isLoading,
      newsListRaw: state => state.news.newsList
    })
  },

  methods: {
    async matchNews (data) {
      if (data) {
        let newsArr = []

        newsArr = this.pushNews(data)

        // let newNews = newsArr.sort((a, b) => (a.publish > b.publish) ? 1 : -1)
        // this.newsList = newNews
        this.newsList = newsArr.reverse()
      }
    },

    pushPublishs (data) {
      if (data) {
        const publishArr = []

        data.forEach(list => {
          publishArr.push(moment(list.publish_datetime).format('YYYY'))
        })

        const newPublishs = this.checkDupNews(publishArr)

        newPublishs.push('All Years')

        const sortPublishs = newPublishs.sort((a, b) => (a < b) ? 1 : -1)

        this.publishs = sortPublishs
      }
    },

    checkDupNews (data) {
      const filter = data.filter((item, i) =>
        data.indexOf(item) === i
      )

      return filter
    },

    pushNews (data) {
      const newsArr = []

      data.forEach(list => {
        const obj = {
          id: list.id,
          name: list.name,
          dec: list.subtitle,
          content: list.content,
          publish: moment(list.publish_datetime).format('MMMM DD[,] YYYY'),
          imgUrl: `https://admanawards.com/storage/app/img/activity/${list.image}`,
          route: {
            name: 'news-detail',
            params: {
              id: list.id
            }
          }
        }

        newsArr.push(obj)
      })

      return newsArr
    },

    loadListMore () {
      this.listNum = this.listNum + 6
      this.clickCount++
    },

    filterYear (year) {
      const filter = this.newsListRaw.filter(list =>
        moment(list.publish_datetime).format('YYYY') === year
      )

      this.newsList = this.pushNews(filter)
    }
  },

  created () {
    if (!this.newsListRaw) {
      this.$store.dispatch('news/getList')
    }

    this.matchNews(this.newsListRaw)
    this.pushPublishs(this.newsListRaw)
  },

  watch: {
    newsListRaw (data) {
      this.matchNews(data)
      this.pushPublishs(data)
    },

    clickCount (count) {
      const limit = (this.newsList.length % 6) - 2

      if (count === limit) {
        this.showBtn = false
      }
    },

    inputFilter (input) {
      if (input) {
        this.selectPublish = 'All Years'

        const filter = this.newsListRaw.filter(news =>
          news.name.toLowerCase().includes(input.toLowerCase())
        )

        const data = this.pushNews(filter)

        this.newsList = data
      }
      if (input === '') {
        this.listNum = 6
        this.matchNews(this.newsListRaw)
      }
    },

    selectPublish (select) {
      this.listNum = 6
      if (select === 'All Years') {
        this.matchNews(this.newsListRaw)
      } else {
        this.filterYear(select)
      }
    },

    isLoading (data) {
      this.showBtn = !data
    },

    newsList (data) {
      if (data.length === 0) {
        this.showBtn = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-main-news {
  margin-top: 22px;

  .box-head {
    .box-filter {
      .box-input {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        height: 52px;

        input {
          padding: 8px 8px;
          width: 100%;
          height: 100%;
          border: 1px solid #ced4da;
          font-size: 1.25rem;
        }

        button {
          width: 60px;
          height: 100%;
          background-color: #ced4da;

          img {
            height: 18px;
          }
        }
      }

      .box-select {
        margin-top: 18px;
        width: 100%;
        height: 52px;

        @media only screen and (min-width: $break-m) {
          margin: 0;
        }

        select {
          padding: 8px 12px;
          width: 100%;
          height: 100%;
          background-color: white;
          background-image: url('../../assets/icons/icon-caret-down.png');
          background-repeat: no-repeat;
          background-position: right .7em top 50%, 0 0;
          background-size: 30px auto, 100%;
          border-color: #CED4DA;
          font-size: 1.25rem;
        }
      }
    }
  }

  .box-cate {
    margin-top: -30px;
    hr {
      position: relative;
      top: 50px;
      border: 1px solid rgba(0,0,0,.1);
    }

    div {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      width: 100px;
      background-color: white;
      text-align: center;
      font-size: 3rem;
    }
  }

  .box-card {
    padding-bottom: 22px;

    .row {
      .col {
        margin-bottom: 22px;
      }
    }

    .box-view-more-btn {
      margin-top: 22px;
      display: flex;
      justify-content: center;

      button {
        padding: 12px 0;
        width: 100%;
        background-color: $active;
        font-size: 1.25rem;
        color: white;

        @media only screen and (min-width: $break-m) {
          width: 320px;
        }
      }
    }
  }

  .box-empty {
    margin-bottom: 22px;
    padding: 122px 0;
    text-align: center;
    font-size: 1.5rem;
    border: 1px dashed #CCC;
  }
}
</style>
